module.exports = __webpack_public_path__ + "static/ghost-of-the-seas-ii_top-view-88e08ddd598326a8ad38c57c5d6dfc1c.jpg";